// Third Party
import * as React from 'react';
import cx from 'classnames';
import {
  useListingFavoriteCreateMutation,
  useListingFavoriteDeleteMutation,
} from '@gql';

// Utils
import { useNotification } from '@contexts/use-notification';
import { useLoginAndSignupModals } from '@contexts/use-login-and-signup-modals';
import { useSession } from 'next-auth/react';

export type IFavoriteButtonProps = {
  listingID: string;
  listingIsFavorited: boolean;
  onFavoritedSuccess?: (isFavorited: boolean) => void;
  size?: 'sm' | 'md' | 'lg';
};

export const FavoriteButton: React.FC<IFavoriteButtonProps> = ({
  listingID,
  listingIsFavorited,
  onFavoritedSuccess,
  size,
}) => {
  const { addNotification } = useNotification();

  const [listingFavoriteCreateMutation] = useListingFavoriteCreateMutation();
  const [listingFavoriteDeleteMutation] = useListingFavoriteDeleteMutation();

  const { data: session } = useSession();
  const { activateLoginModal } = useLoginAndSignupModals();

  const [favLoading, setFavLoading] = React.useState<boolean>(false);

  async function handleFav(listingId: string): Promise<void> {
    if (session?.user != null) {
      setFavLoading(true);
      try {
        if (!listingIsFavorited == true) {
          await listingFavoriteCreateMutation({
            variables: {
              input: {
                listingId: listingId,
              },
            },
          });
        } else {
          await listingFavoriteDeleteMutation({
            variables: {
              input: {
                listingId: listingId,
              },
            },
          });
        }
        if (onFavoritedSuccess) {
          void onFavoritedSuccess(!listingIsFavorited);
        }
      } catch (errors) {
        addNotification({
          type: 'error',
          title: 'Something went wrong...',
          message: 'Please try again later.',
        });
      } finally {
        setFavLoading(false);
      }
    } else {
      activateLoginModal();
    }
  }

  return (
    <div>
      <button
        disabled={favLoading}
        onClick={() => handleFav(listingID)}
        className="focus:outline-none"
      >
        {listingIsFavorited ? (
          <img
            src="/assets/svg/favHeartFilled.svg"
            className={cx(
              size === 'lg' ? 'w-8 h-8' : size === 'md' ? 'w-5 h-5' : 'w-4 h-4'
            )}
          />
        ) : (
          <img
            src="/assets/svg/favHeart.svg"
            className={cx(
              size === 'lg' ? 'w-8 h-8' : size === 'md' ? 'w-5 h-5' : 'w-4 h-4'
            )}
          />
        )}
      </button>
    </div>
  );
};
